import { useEffect } from 'react';
import useMap from './useMap';

/**
 * Attaches to the style.load map event and calls onStyleChange after a delayDuration.
 * @param onStyleChange callback to run when the map style changes, after delayDuration
 * @param onInitialLoad callback to run on initial load
 * @param delayDuration setTimeout duration in milliseconds
 */
export function useDelayedOnStyleChange(onStyleChange: () => void, onInitialLoad?: () => void, delayDuration: number = 100) {
  const map = useMap();

  useEffect(() => {
    if (!map) {
      return;
    }

    const delayedOnStyleChange = () =>
      setTimeout(() => {
        onStyleChange();
      }, delayDuration);

    onInitialLoad?.();
    map.on('style.load', delayedOnStyleChange);
    return () => {
      map.off('style.load', delayedOnStyleChange);
    };
  }, [delayDuration, map, onInitialLoad, onStyleChange]);
}
